import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function IdeaSendEmail({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.ideaSendEmail"
      values={{
        name: util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Unknown",
      }}
    />
  );
}
